export default __webpack_public_path__ + "static/partner9-3586daa5bcf4a5f983ba30f607a1eaae.jpg";